<template>
    <div>
        <Head>
            <title>{{ pageName }}</title>
            <meta name="description" :content="cmsContent.data.metaDescription" />
            <meta name="keywords" :content="cmsContent.data.metaKeywords" />
        </Head>
        <h1 class="headline-l cms-title">{{ pageName }}</h1>
        <cms content-prop="cmsContent" model="content-section" driver="builder" :components="getBuilderComponents()" is-section :search-params="searchParams" v-model="builderData" :readable-fields="['pageName']"/>
    </div>
</template>
<script lang="ts" setup>
import Cms from "@/components/Cms.vue";
import { ref, computed } from "vue";
import { getBuilderComponents } from "@root/builder-components.ts";
import { Head } from "@inertiajs/vue3";

let props = defineProps({
    language: {
        type: String,
        default: '',
    },
    cmsContent: {
        type: Object,
        default: () => ({
            data: {
                pageName: null,
                metaDescription: "",
                metaKeywords: ""
            }
        })
    }
})

let builderData = ref({
    pageName: ""
})

let pageName = computed(()=>{
    return builderData.value?.pageName;
});

let searchParams = computed(()=>{
    return {
        "data.pageUrl.$eq": !['', null].includes(props.language)? `shop/reseller-agreement/${props.language}` : `shop/reseller-agreement`
    }
});

</script>